import * as swcHelpers from '@swc/helpers';
import { pushSdAction, getPriceSpecificationConfig, createPriceSpecification, parseProductData, ActionType, calcPrice } from '@grandvisionhq/analytics';
import { getNestedProperty, isDefined, optionalKey } from '@grandvisionhq/utils';

function createSubscriptionPriceSpecification(activeVariant, pricePerMonth) {
    const currency = pricePerMonth.currencyCode;
    const subscriptionPriceSpecification = {
        '@type': 'CompoundPriceSpecification',
        name: 'Price',
        price: calcPrice(pricePerMonth.centAmount),
        priceCurrency: currency,
        valueAddedTaxIncluded: true
    };
    return subscriptionPriceSpecification;
}
const createViewProductEvent = ({ product , activeSKU , url , locale , isSubscriptionSelected , pricePerMonth , extra  })=>{
    var ref, ref1;
    const activeVariant = [
        product.masterVariant,
        ...product.variants
    ].find((variant)=>variant.sku === activeSKU
    ) || product.masterVariant;
    const subscriptionProductSku = (ref1 = (ref = activeVariant.attributes) === null || ref === void 0 ? void 0 : ref.find(({ name  })=>name === 'subscriptionProductSKU'
    )) === null || ref1 === void 0 ? void 0 : ref1.value;
    const vat = getNestedProperty(product, 'taxCategory.obj.rates', []).find((rate)=>rate.includedInPrice
    );
    var _prices;
    const pricing = ((_prices = activeVariant.prices) !== null && _prices !== void 0 ? _prices : []).find((price)=>typeof price.value.centAmount !== 'undefined'
    );
    const priceSpecification = isDefined(pricing) ? getPriceSpecificationConfig(pricing, vat.amount) : undefined;
    const offers = [
        {
            '@type': 'Offer',
            priceSpecification: isSubscriptionSelected && pricePerMonth ? createSubscriptionPriceSpecification(activeVariant, pricePerMonth) : createPriceSpecification(priceSpecification, activeSKU)
        }, 
    ];
    const { name: name1 , image , description , brand , category , sku  } = parseProductData(product, activeVariant, locale);
    const action = {
        '@context': 'https://schema.org',
        '@type': ActionType.Action,
        name: 'product_detail',
        // The object currently has the same structure as what is sent by the `Product` SD component.
        object: swcHelpers.objectSpread({
            '@type': 'Product',
            '@id': `${url}#product`,
            url,
            sku: isSubscriptionSelected ? subscriptionProductSku : sku,
            skuMaster: product.masterVariant.sku,
            purchaseModel: isSubscriptionSelected ? 'subscription' : 'single purchase',
            image,
            name: name1 && String(name1) || sku
        }, optionalKey('description', description), optionalKey('brand', brand), optionalKey('category', category), optionalKey('offers', offers), extra)
    };
    return action;
};
const viewProductSdEvent = (params)=>{
    const action = createViewProductEvent(params);
    pushSdAction(action);
};

export { createViewProductEvent, viewProductSdEvent };
//# sourceMappingURL=structured-data.js.map
